import { jsx as o } from "react/jsx-runtime";
import { Icon as n } from "../Icon.js";
const L = ({ className: r, titleAccess: C }) => /* @__PURE__ */ o(n, { className: r, titleAccess: C, viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ o(
  "path",
  {
    d: "M12.0004 2.39844L13.9319 7.42028C14.2026 8.12418 14.338 8.47613 14.5485 8.77217C14.735 9.03455 14.9643 9.26379 15.2267 9.45036C15.5227 9.66086 15.8746 9.79623 16.5785 10.067L21.6004 11.9984L16.5786 13.9299C15.8747 14.2006 15.5227 14.336 15.2267 14.5465C14.9643 14.7331 14.735 14.9623 14.5485 15.2247C14.338 15.5207 14.2026 15.8727 13.9319 16.5766L12.0004 21.5984L10.0689 16.5766C9.79818 15.8727 9.66282 15.5207 9.45231 15.2247C9.26575 14.9623 9.03651 14.7331 8.77413 14.5465C8.47808 14.336 8.12613 14.2006 7.42223 13.9299L2.40039 11.9984L7.42223 10.067C8.12613 9.79623 8.47808 9.66086 8.77413 9.45036C9.03651 9.26379 9.26575 9.03455 9.45231 8.77217C9.66282 8.47613 9.79818 8.12418 10.0689 7.42028L12.0004 2.39844Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) });
export {
  L as IconQuadStar
};
